export default __webpack_public_path__ + "static/media/facebookDeskMobile.43e82d2e.svg";